export const hasEnumFlag = (flags, flag) => (flags & flag) === flag;
//# sourceMappingURL=enum.js.map